import React, { useCallback } from "react"
import { useDispatch } from "react-redux"
import { Button, Stack } from "@mui/material"
import {
	PSE_STATUS,
	loadProductionStepExecution,
	PSEGoOneStepBack,
	updateProductionStepExecutionStatusToDone,
	showProductionStepsSupervision
} from "../../actions/ProductionSteps/ProductionStepExecutions"
import ProductionStepExecutionFooter from "./ProductionStepExecutionFooter"
import { StyledMainContainer, StyledSubStatusTitle } from "./styledComponents"
import CommentsAlert from "./preview/PSECommentsAlert"
import PSEPreparation from "./preview/PSEPreparation"
import ProductionStepsExecutionFixedHeader from "./ProductionSteoExecutionsFixedHeader"

const ProductionStepExecutionToTest = ({
	productionStepExecution
}) => {

	const dispatch = useDispatch()

	const handleBack = () => dispatch(showProductionStepsSupervision())

	const handleStepBack = async () => {
		await PSEGoOneStepBack(productionStepExecution.objectId || productionStepExecution.id)
		dispatch(loadProductionStepExecution({ id: productionStepExecution.objectId || productionStepExecution.id }))
	}

	const handleTestingConfirm = useCallback(() => {
		dispatch(updateProductionStepExecutionStatusToDone(productionStepExecution.objectId, { status: PSE_STATUS.done }))
	}, [productionStepExecution])

	return (
		<>
			{/* header */}
			<ProductionStepsExecutionFixedHeader onBack={handleBack} />

			{/* body */}
			<StyledMainContainer sx={{ paddingTop: 0 }}>
				<Stack gap={2} sx={{ p: 3 }}>
					<StyledSubStatusTitle>Tester la préparation.</StyledSubStatusTitle>
					<PSEPreparation
						productionStepExecution={productionStepExecution}
						isEnd
					/>
					<CommentsAlert>Vous pouvez ajouter un commentaire (goût, texture etc.) si besoin.</CommentsAlert>
				</Stack>
			</StyledMainContainer>

			{/* footer */}
			<ProductionStepExecutionFooter
				rightAction={
					<Button variant="contained" onClick={handleTestingConfirm}>
						Valider la préparation
					</Button>
				}
				leftAction={
					<Button variant="outlined" onClick={handleStepBack}>
						Retour
					</Button>
				}
			/>
		</>
	)
}

export default ProductionStepExecutionToTest